import apiClient  from './Client';

class CanvasService{
    async CreateCanvas(productId: number, postData: any) { 
        try {
        const response = await apiClient.post(`/Canvas/${productId}/create`, postData); 
        console.log(response);
        return response.data;
          
        } catch (err:any) {
          if(err.response.status===400)
          {
            console.log(err); 
            if(err.response.data.message==="Error in creating new canvas")
              return "Failed to create canvas";
          }
            
        }
    };

    async UpdateCanvas(productId: number, postData: any, canvasID: number) { 
      try {
      const response = await apiClient.put(`/Canvas/update/${canvasID}`, postData); 
      console.log(response);
      return response.data;
        
      } catch (err:any) {
        if(err.response.status===400)
        {
          console.log(err); 
          if(err.response.data.message==="Error in creating new canvas")
            return "Failed to create canvas";
        }
          
      }
  };

  async GetCanvas(canvasID: number){
    try {
      const response = await apiClient.get(`/Canvas/get-canvas/${canvasID}`);
      return response.data;
    } catch (error) {
        console.error("Failed to fetch canvas", error);
        throw error;  
    }
  }
}
export default new CanvasService()